import React from 'react';
import { Report } from 'apiTypes';
import { PromptGroup } from 'types/candidateStories';
import PromptSummaryGeneralSection from './PromptSummaryGeneralSection';
import PromptSummaryRecordSection from './PromptSummaryRecordSection';

const CandidateStoryPromptSummary = ({
  candidateStories,
  selectedRecords,
  promptGroups,
}: {
  candidateStories: any;
  selectedRecords: Report[];
  promptGroups: PromptGroup[];
}) => {
  const summaryPromptItems = candidateStories.promptGroup?.content || {};
  const { general = {}, ...recordResponses } = summaryPromptItems;

  return (
    <div data-testid='candidate-story-prompt-summary'>
      <PromptSummaryGeneralSection
        general={general}
        promptGroups={promptGroups}
      />
      <PromptSummaryRecordSection
        recordResponses={recordResponses}
        selectedRecords={selectedRecords}
        promptGroups={promptGroups}
      />
    </div>
  );
};

export default CandidateStoryPromptSummary;
